import { useCallback } from "react";
import { ComplianceProgramCalibrationType } from "types/graphql-schema";

import Layout from "@components/layout/layout";

import CalibratedQuestionList from "./calibrated-question-list";
import useAssessmentCalibrationData from "./use-assessment-calibration-data";

const AssessmentDeliveryCalibrationChangelog = ({
  assessmentTemplateId,
  calibration,
  complianceProgramId,
  targetId,
}: {
  assessmentTemplateId?: number | null;
  calibration?: ComplianceProgramCalibrationType;
  complianceProgramId?: number;
  targetId?: number;
}) => {
  const canShowChangelog =
    calibration === ComplianceProgramCalibrationType.PostCalibration ||
    calibration === ComplianceProgramCalibrationType.PreCalibration;

  const { allCalibrations, questions } = useAssessmentCalibrationData({
    complianceProgramId: canShowChangelog ? complianceProgramId : undefined,
    templateId: canShowChangelog ? assessmentTemplateId : undefined,
    targetId: canShowChangelog ? targetId : undefined,
  });

  const handleScrollToQuestion = useCallback((questionId: number) => {
    const element = document.getElementById(
      `assessment-question-${questionId}`
    );
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, []);

  return (
    canShowChangelog &&
    questions.length > 0 && (
      <div className="mt-6">
        <Layout.MainSubSection
          title="Calibration Comments and Edits"
          collapsible
          defaultIsExpanded={true}
          className="mb-6"
        >
          <div className="p-2 border rounded-lg">
            <CalibratedQuestionList
              allCalibrations={allCalibrations}
              questions={questions}
              onScrollToQuestion={handleScrollToQuestion}
            />
          </div>
        </Layout.MainSubSection>
      </div>
    )
  );
};

export default AssessmentDeliveryCalibrationChangelog;
